import { useRequiredParam } from '@/hooks/useRequiredParam';
import { MemoDetails } from '@/modules/memos/MemoDetails/MemoDetails';

export function MemoDetailsPage() {
  const householdId = useRequiredParam('householdId');
  const memoId = useRequiredParam('memoId');

  return <MemoDetails householdId={householdId} memoId={memoId} />;
}
